import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/settings.vue
var s = {
	name: "DtIconSettings",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--settings"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Settings",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		fill: "currentColor",
		"fill-rule": "evenodd",
		"clip-rule": "evenodd"
	}, [...t[0] || (t[0] = [i("path", { d: "M6 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM5 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z" }, null, -1), i("path", { d: "M4.83.94A1.5 1.5 0 0 1 5.89.5h.22A1.5 1.5 0 0 1 7.61 2v.093a.5.5 0 0 0 .25.429h.001l.215.125a.5.5 0 0 0 .522-.012l.06-.033a1.5 1.5 0 0 1 2.04.552l.11.19a1.502 1.502 0 0 1-.544 2.047l-.072.043-.011.006a.5.5 0 0 0-.246.433v.254a.5.5 0 0 0 .244.431l.066.036.016.008a1.5 1.5 0 0 1 .548 2.046l-.111.198a1.5 1.5 0 0 1-2.04.552l-.064-.035a.5.5 0 0 0-.518-.01l-.216.125a.5.5 0 0 0-.25.429V10a1.5 1.5 0 0 1-1.5 1.5h-.22a1.5 1.5 0 0 1-1.5-1.5v-.09a.5.5 0 0 0-.25-.432h-.001l-.215-.125a.5.5 0 0 0-.52.011l-.062.034a1.5 1.5 0 0 1-2.04-.552l-.11-.19a1.502 1.502 0 0 1 .544-2.047l.072-.043.011-.007a.5.5 0 0 0 .246-.432v-.255a.5.5 0 0 0-.25-.429.506.506 0 0 1-.034-.021l-.057-.038a1.5 1.5 0 0 1-.532-2.039l.11-.19a1.5 1.5 0 0 1 2.04-.553l.068.037a.5.5 0 0 0 .514.009l.216-.126a.5.5 0 0 0 .25-.433V2c0-.398.158-.78.44-1.06Zm4.105 4.934v.252a1.5 1.5 0 0 0 .77 1.313l.06.032a.5.5 0 0 1 .177.68l-.11.195a.5.5 0 0 1-.682.18l-.015-.007-.068-.037a1.5 1.5 0 0 0-1.492.005l-.216.125A1.5 1.5 0 0 0 6.61 9.91V10a.5.5 0 0 1-.5.5h-.22a.5.5 0 0 1-.5-.5v-.09a1.5 1.5 0 0 0-.75-1.298l-.214-.124-.001-.001a1.5 1.5 0 0 0-1.49-.005l-.07.037-.015.008a.5.5 0 0 1-.682-.183l-.11-.19a.5.5 0 0 1 .183-.681l.075-.046a1.5 1.5 0 0 0 .749-1.303v-.257a1.5 1.5 0 0 0-.734-1.28l-.064-.043a.5.5 0 0 1-.21-.7l.11-.189a.5.5 0 0 1 .683-.182l.015.008.067.036a1.5 1.5 0 0 0 1.493-.004l.216-.125a1.5 1.5 0 0 0 .749-1.295V2a.5.5 0 0 1 .5-.5h.22a.5.5 0 0 1 .5.5v.09a1.5 1.5 0 0 0 .75 1.298l.214.124.001.001a1.5 1.5 0 0 0 1.49.006l.07-.038.015-.008a.5.5 0 0 1 .682.183l.11.19a.5.5 0 0 1-.183.681l-.076.046a1.5 1.5 0 0 0-.548.549v.002a1.5 1.5 0 0 0-.2.75Z" }, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=settings.js.map